
import React from 'react';
import TestimonialCard from '@/components/TestimonialCard';

const EmployeeTestimonials = () => {
  const testimonials = [
    {
      quote: "Ik ben ontzettend blij met de kansen die deze organisatie biedt. Ze hebben een scherp oog voor potentieel en investeren echt in hun medewerkers.",
      author: "Sarah M.",
      company: "De Afsprakenmaker",
      role: "Sales Development Medewerker"
    },
    {
      quote: "Vertrouwen en autonomie zijn hier geen lege woorden. Je krijgt echt de vrijheid om je job in te vullen en je eigen aanpak te ontwikkelen.",
      author: "Kevin D.",
      company: "De Afsprakenmaker", 
      role: "Senior Sales Consultant"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Wat onze medewerkers zeggen
            </h2>
            <p className="text-xl text-gray-600">
              Ontdek waarom mensen graag bij De Afsprakenmaker werken
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard
                key={index}
                quote={testimonial.quote}
                author={testimonial.author}
                company={testimonial.company}
                role={testimonial.role}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmployeeTestimonials;
